import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSList
} from "@wingspanhq/fe-component-library";
import {
  IBulkCollaboratorBatch,
  IEngagementResponse
} from "@wingspanhq/payments/dist/interfaces";
import { getUploadedFilename } from "../../utils/getUploadedFilename";
import { BulkResource } from "../../types";
import { getDisplayImportStatusValue } from "../../utils/getDisplayImportStatusValue";
import { getBatchCreatorName } from "../../utils/getBatchCreator";

type Props = {
  bulkBatch: IBulkCollaboratorBatch;
  engagement?: IEngagementResponse;
};

export const ContractorBatchDetailsWidget: React.FC<Props> = ({
  bulkBatch,
  engagement
}) => {
  return (
    <WSCard header="Details" divider>
      <WSList gap="XL">
        <WSDataItem
          inline
          label="Original spreadsheet"
          value={
            getUploadedFilename(bulkBatch, BulkResource.Collaborator) || "--"
          }
        />
        <WSDataItem
          inline
          label="Imported to contractors"
          value={getDisplayImportStatusValue(bulkBatch.status)}
        />
        <WSDataItem
          inline
          label="Created"
          value={toWSDateString(bulkBatch.createdAt)}
        />
        <WSDataItem
          inline
          label="Creator"
          value={getBatchCreatorName(bulkBatch)}
        />
        <WSDataItem inline label="Engagement" value={engagement?.name} />
      </WSList>
    </WSCard>
  );
};
